export default __webpack_public_path__ + "static/media/img1.14351bd8.jfif";